import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Icon } from '@toggle/design-system';
import clsx from 'clsx';
import React from 'react';

import styles from './WebsiteCard.module.scss';

interface WebsiteCardProps {
  id: string;
  title: string;
  url: string;
  favicon: string;
  handleRemove?: (id: string) => void;
}

export const WebsiteCard = ({
  id,
  title,
  url,
  favicon,
  handleRemove,
}: WebsiteCardProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div className={styles.cardWrapper} ref={setNodeRef} style={style}>
      <div className={styles.dragHandle} {...attributes} {...listeners}>
        <Icon iconName="GripDotsVertical" size={16} />
      </div>
      <div className={clsx(styles.content, { [styles.onlyUrl]: !title })}>
        <img className={styles.favicon} src={favicon} alt={title} />
        <div className={styles.infoWrapper}>
          <span className={styles.title}>{title}</span>
          <span className={styles.url}>{url}</span>
        </div>
      </div>
      <Button
        iconName="Close"
        size="xsmall"
        variant="empty"
        onClick={() => {
          handleRemove?.(id);
        }}
      />
    </div>
  );
};
